<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title"><a id="ncx_1"></a><a id="page_0001"></a>Preaching Hebrews</h1><br/>
<h1 class="subtitle"><a id="ncx_2"></a>Rochester College Lectures on Preaching Volume 4</h1><br/><br/><br/><br/>
<h2 class="author"><a id="ncx_3"></a><span>David Fleer and Dave Bland, editors</span></h2>
<br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780891128793_Part02.vue?637c2a86